import React, { Fragment } from 'react';

const STEPS = [
  { n: 1, label: 'Current' },
  { n: 2, label: 'Compare' },
  { n: 3, label: 'Pipeline' },
  { n: 4, label: 'Results' },
];

export default function Stepper({ step, onGo, furthest }) {
  return (
    <nav
      className="flex items-center gap-2 mb-8"
      data-testid="bta-stepper"
      aria-label="Analyzer progress"
    >
      {STEPS.map((s, i) => (
        <Fragment key={s.n}>
          <button
            type="button"
            disabled={s.n > furthest}
            onClick={() => onGo(s.n)}
            data-testid={`bta-stepper-${s.label.toLowerCase()}`}
            className={
              'flex items-center gap-2 px-3 py-1.5 rounded text-sm transition ' +
              (s.n === step
                ? 'bg-[#2FA163] text-white shadow'
                : s.n < step
                ? 'bg-[#2FA163]/10 text-[#286C4E] hover:bg-[#2FA163]/20'
                : s.n <= furthest
                ? 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                : 'bg-slate-50 text-slate-400 cursor-not-allowed')
            }
          >
            <span
              className={
                'w-5 h-5 rounded-full flex items-center justify-center text-xs font-semibold ' +
                (s.n === step
                  ? 'bg-white text-[#2FA163]'
                  : s.n < step
                  ? 'bg-[#2FA163] text-white'
                  : 'bg-slate-300 text-white')
              }
            >
              {s.n < step ? '✓' : s.n}
            </span>
            <span className="font-medium">{s.label}</span>
          </button>
          {i < STEPS.length - 1 && <div className="h-px w-6 bg-slate-300" />}
        </Fragment>
      ))}
    </nav>
  );
}
